import React, { useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export const ReviewForm = React.memo(function ReviewForm({ place, theme, user, color, onSubmitted, setShowAuth }) {
  const isDark = theme === 'dark';
  const C = (k) => { const d=isDark,m={surf2:d?'rgba(255,255,255,0.03)':'rgba(139,92,246,0.04)',bord:d?'rgba(255,255,255,0.07)':'rgba(139,92,246,0.10)',txt:d?'#ffffff':'#1E1048',txt2:d?'rgba(255,255,255,0.5)':'#4B3D7A',inp:d?'rgba(255,255,255,0.05)':'rgba(139,92,246,0.06)'}; return m[k]||''; };
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const handleSubmit = useCallback(async () => {
    if (!comment.trim()) return;
    setSubmitting(true);
    console.log('[Reviews] INSERT payload:', {school_id: place.id, user_id: user.id, user_name: user.name||user.email, rating, comment});
    const { data, error } = await supabase.from('school_reviews').insert({ school_id: place.id, user_id: user.id, user_name: user.name||user.email, rating, comment, is_approved: false });
    console.log('[Reviews] INSERT result:', data, error);
    setSubmitting(false);
    if (error) { alert('Yorum gönderilemedi: ' + error.message); return; }
    setRating(5);
    setComment('');
    setDone(true);
  }, [place.id, user, rating, comment]);
  if (!user) return (
    <div style={{textAlign:'center',padding:'16px 0 20px',color:C('txt2'),fontSize:13}}>
      Yorum yapmak için <button onClick={()=>setShowAuth(true)} style={{background:'none',border:'none',color:'#A8DAFF',cursor:'pointer',fontWeight:700,fontSize:13,fontFamily:'DM Sans,sans-serif'}}>giriş yapın</button>
    </div>
  );
  if (done) return (
    <div style={{background:C('surf2'),borderRadius:12,padding:14,border:'1px solid '+C('bord'),marginBottom:16,textAlign:'center',color:C('txt2'),fontSize:13}}>
      ✅ Yorumunuz incelendikten sonra yayınlanacak.
    </div>
  );
  return (
    <div style={{background:C('surf2'),borderRadius:12,padding:14,border:'1px solid '+C('bord'),marginBottom:16}}>
      <div style={{color:C('txt'),fontSize:13,fontWeight:700,marginBottom:10}}>Yorum Yap</div>
      <div style={{display:'flex',gap:6,marginBottom:10}}>
        {[1,2,3,4,5].map(s=>(
          <button key={s} onClick={()=>setRating(s)} style={{fontSize:22,background:'none',border:'none',cursor:'pointer',color:s<=rating?'#FFE66D':'rgba(255,255,255,0.2)',padding:2}}>★</button>
        ))}
      </div>
      <textarea placeholder="Yorumunuzu yazın..." value={comment} onChange={e=>setComment(e.target.value)}
        style={{width:'100%',background:C('inp'),border:'1px solid '+C('bord'),borderRadius:9,padding:'10px 12px',color:C('txt'),fontSize:16,outline:'none',fontFamily:'DM Sans,sans-serif',resize:'vertical',minHeight:70,boxSizing:'border-box',marginBottom:10,touchAction:'manipulation'}}/>
      <button onClick={handleSubmit} disabled={submitting}
        style={{padding:'8px 18px',borderRadius:9,background:'linear-gradient(135deg,'+color+','+color+'bb)',border:'none',color:'#000',fontSize:12,fontWeight:700,cursor:'pointer'}}>
        {submitting?'Gönderiliyor...':'Gönder'}
      </button>
    </div>
  );
}, (prev, next) => prev.place?.id === next.place?.id && prev.user?.id === next.user?.id && prev.theme === next.theme);
